import type { ProjectMember } from "@/lib/api";

/** Primary label for settings members table (never raw user id). */
export function projectMemberPrimaryLabel(member: Pick<ProjectMember, "name" | "email">): string {
  if (member.name?.trim()) return member.name.trim();
  if (member.email?.trim()) {
    const local = member.email.split("@")[0]?.trim();
    return local || member.email.trim();
  }
  return "Member";
}

export function projectMemberSecondaryLine(member: Pick<ProjectMember, "email" | "name">): string | null {
  if (member.email?.trim()) return member.email.trim();
  return null;
}
